"use strict";

/* global HTMLElement, NodeList, this */
window._weakMap = new WeakMap();


HTMLElement.createFromHTML = function(html) {
   let dummy = document.createElement('div');
   dummy.innerHTML = html;
   return dummy.firstElementChild;
}

HTMLElement.prototype.getIndex = function() {
   return [...this.parentNode.children].indexOf(this);
}

if (!HTMLElement.empty) {
   HTMLElement.prototype.empty = function() {
      while (this.firstChild) this.removeChild(this.firstChild);
      return this;
   };
}

HTMLElement.prototype.setStyles = function(styles) {
    Object.assign(this.style, styles);
};

HTMLElement.prototype.createElement = function(type, classes, attributes, children) {
   let element = document.createElement(type);

   if (classes) {
      for (let cl of classes.split(' ')) {
         element.classList.add(cl);
      }
   }

   if (attributes !== undefined) {
      for (let attrName in attributes) {
         element.setAttribute(attrName, attributes[attrName]);
      }
   }

   if (children !== undefined) {
      if (Array.isArray(children)) {
         for (let child of children) element.appendChild(child);
      }
      else {
         element.appendChild(children);
      }
   }

   if (this instanceof HTMLElement) {
      this.appendChild(element);
   }

   return element;

};

HTMLElement.prototype.addClass = function(cls) {
   cls.split(' ').map(c => { this.classList.add(c)});
    //this.classList.add(cls);
};

HTMLElement.prototype.removeClass = function(cls) {
    this.classList.remove(cls);
};

let _dataMap = new WeakMap();

HTMLElement.prototype.setData = function(name, value) {

   let data = _dataMap.get(this) || {};
   data[name] = value;
   _dataMap.set(this, data);

};

HTMLElement.prototype.getData = function(name) {

   if (!_dataMap.has(this)) return undefined;
   return _dataMap.get(this)[name];

};

HTMLElement.prototype.parents = function(selector) {
	var elements = [];
	var elem = this;
	var ishaveselector = selector !== undefined;

	while ((elem = elem.parentElement) !== null) {
		if (elem.nodeType !== Node.ELEMENT_NODE) {
			continue;
		}

		if (!ishaveselector || elem.matches(selector)) {
			elements.push(elem);
		}
	}

	return elements;
};


let nodeListFunctions = ['empty', 'setAttribute', 'removeAttribute', 'addEventListener', 'addClass', 'removeClass', 'setStyles'];

for (let f of nodeListFunctions) {
   let x = HTMLElement.prototype[f];
   NodeList.prototype[f] = function() {
      for (let node of this) node[f](...arguments);
   };
}


// Function from David Walsh: http://davidwalsh.name/css-animation-callback
function whichTransitionEvent() {
  var t,
      el = document.createElement("fakeelement");

  var transitions = {
    "transition"      : "transitionend",
    "OTransition"     : "oTransitionEnd",
    "MozTransition"   : "transitionend",
    "WebkitTransition": "webkitTransitionEnd"
  }

  for (t in transitions){
    if (el.style[t] !== undefined){
      return transitions[t];
    }
  }
}

window.transitionEndEvent = whichTransitionEvent();
